import Icon from 'components/Icon'
import React, { useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'

const S = {
    Wrapper: styled.div`
        position: relative;
        width: 220px;
        margin-left: 20px;
        background-color: white;
        border-radius: 4px;
        z-index: 1;
    `,
    DatePicker: styled(ReactDatePicker)`
        position: relative;
        z-index: 9;
        background-color: transparent;
    `,
    Icon: styled.div`
        position: absolute;
        top: 8px;
        right: 10px;
        z-index: -1;
    `
}

interface Props {
    format?: string
    onChange: (e: any) => void
    className?: string
    placeHolder?: string
}

const DateFilter = ({
    format = 'dd/MM/yyyy',
    onChange = () => null,
    className,
    placeHolder
}: Props) => {
    const [value, setValue] = useState(null)
    const handleChangeDate = (val) => {
        onChange(val)
        setValue(val)
    }

    return (
        <S.Wrapper>
            <S.DatePicker
                dateFormat={format}
                selected={value ? new Date(value) : null}
                onChange={handleChangeDate}
                className={className}
                placeholderText={placeHolder}
            />
            <S.Icon>
                <Icon icon="calendar" size={18} />
            </S.Icon>
        </S.Wrapper>
    )
}

export default DateFilter
